import { render, staticRenderFns } from "./wrapVideo.vue?vue&type=template&id=722c89f7&scoped=true&"
import script from "./wrapVideo.vue?vue&type=script&lang=js&"
export * from "./wrapVideo.vue?vue&type=script&lang=js&"
import style0 from "./wrapVideo.vue?vue&type=style&index=0&id=722c89f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c89f7",
  null
  
)

export default component.exports